import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY


export const getActiveColaborators = async (setDataTable) => {
    api.get(`${urlApi}/talentoHumano/getColaboradoresActivos`).then((res) => {
        setDataTable(res.data)
    })
        .catch((error) => {
        })
}

export const getInactiveColaborators = (setDataTable) => {
    api.get(`${urlApi}/talentoHumano/getColaboradoresInactivos`).then((res) => {
        setDataTable(res.data)
    })
        .catch((error) => {
        })
}
export const addUsuariosColaborador = async (params) => {
    await api.post(`${urlApi}/talentoHumano/addUsuariosColaborador`, params).then((res) => {
        // Swal.fire({
        //     icon: "success",
        //     title: "Éxito",
        //     text: "Colaborador agregado correctamente",
        // });
    })
        .catch((error) => {
        })
}
export const updateUsuariosColaborators = async (params) => {
    await api.patch(`${urlApi}/talentoHumano/editUsuariosColaborador`, params).then((res) => {

    })
        .catch((error) => {
            console.log("error".error);

        })
}

export const getColaboratorById = async (id) => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getColaboradorById`, {
            params: {
                id: id
            }
        });
        return response.data[0];
    } catch (error) {
        throw error;
    }
}

export const getCivilSates = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getCivilState`);

        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getActasAdmin = async (id) => {
    try {
        const actas = await api.get(`${urlApi}/talentoHumano/getActasAdministrativas`, {
            params: {
                id: id
            }
        });

        return actas.data;
    } catch (error) {
        console.error("Error getting colaborator actas", error);
    }
}

export const getScholarTypes = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getScholarTypes`);

        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getColaboratorsList = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getActiveColabList`);

        return response.data.map(colaborator => ({
            label: colaborator.NOMBRE,
            value: colaborator.ID
        }));
    } catch (error) {
    }
}

export const getPuestos = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getPuestosColaborador`);
        const mappedData = response.data.map(puesto => ({
            label: puesto.PUESTO,
            value: puesto.ID
        }));
        return mappedData;
    } catch (e) {
        throw new Error(e);
    }
}


export const updateColaborador = async (userData) => {
    try {
        const response = await api.patch(`${urlApi}/talentoHumano/updateColaborador`, userData);

        Swal.fire({
            icon: "success",
            title: "Usuario actualizado correctamente",
            showConfirmButton: false,
            timer: 1500,
        });
        return response.data;
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: "Error al actualizar el usuario",
            text: error.response ? error.response.data.message : "Error desconocido",
        });
        throw error;
    }
}

export const getPuestoColaborador = async (id) => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getPuestoByColaborador`, {
            params: {
                id: id
            }
        });
        return response.data.ID_PUESTO;
    } catch (error) { }
}

export const updatePuesto = (data) => {
    try {
        const response = api.post(`${urlApi}/talentoHumano/updatePuestoColaborador`, { dataReq: data });
        return response.data;
    } catch (e) {
        throw new Error(e);
    }
}

